import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService,JwtService, FormSessionCanDeactivate } from '../shared';
import { environment } from '../shared/config/app-config';
import { Router, ActivatedRoute } from '@angular/router';
import { DxDataGridComponent,
  DxDataGridModule,
  DxSelectBoxModule,
  DxCheckBoxModule,DxButtonModule } from 'devextreme-angular';

@Component({
  selector: 'app-client-setup',
  templateUrl: './client-setup.component.html',
  styleUrls: ['./client-setup.component.css']
})
export class ClientSetupComponent extends FormSessionCanDeactivate {

  currentUser:any;
  dateValidation:any = false;
  imageURL: string = environment.cloudeImageURL;
  dateformat:any;
  clientList:any;
  setMode:any;
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  getTotalPageCount () {
    return this.Userservice.translateText('hospital_portal.mytodos.pagination.label');
  }
  constructor(private Userservice: UserService,private router: Router) {
    super();
  }

  ngOnInit() {

    this.setMode = 'all'
    
    this.Userservice.currentUser.subscribe(
      (userData) => {
        this.currentUser = userData;
       this.currentUser.status = true;
       if(this.currentUser.item){
       //this.setmask = this.currentUser.item.phoneFormat.split('#').join('0');
					if(this.currentUser.item.dateFormat.toLowerCase() == 'mmddyyyy'){
						this.dateformat = environment.dateFormat;
					}else if(this.currentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy'){
						this.dateformat = 'DD/MM/YYYY'
					}
          if(this.currentUser.item.hostModel=="CLOUD")
		this.imageURL = environment.cloudeImageURL;
	else   
    this.imageURL = environment.vmImageURL;
          //this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue',showWeekNumbers: false,dateInputFormat: this.dateformat});
        }
   });

    
    
    this.getAllclientforStyker();
  }

  setName:string;
  getAllclientforStyker(){
    if(this.setMode=="P"){
      this.setName = "Practice"
    }
    else if(this.setMode=="H"){
      this.setName = "Hospital"
    }
    else{
      this.setName ="Client"
    }


    let self = this;
    self.Userservice.getAllclientforStyker(this.setMode,this.currentUser.item.userAccountId).subscribe(
      practice=>{
        this.clientList = practice
        //console.log(this.clientList,'practice')
        //this.tem_var = true;
        for(var i = 0;i<this.clientList.length;i++){
          if(this.clientList[i].active){
            this.clientList[i].stat = 'Active'
          }else{
            this.clientList[i].stat = 'Inactive'
          }
        }
      }
    )
  }

  navigateToUser(obj){
    // alert(JSON.stringify(obj))
    this.router.navigateByUrl('/stykeruser/'+obj.hospitalId);
  }

  logout() {
  this.Userservice.logoutuser(this.currentUser.item.useAccountId)
  this.Userservice.purgeAuth();
  if (window.localStorage['plogin']) {
    var plogin = window.localStorage['plogin']
    window.localStorage.removeItem('plogin');
    //window.localStorage.clear()
    this.router.navigateByUrl('/plogin/' + plogin);

  } else {
    //this.currentUser.status==false
    //window.localStorage.clear()
    this.router.navigateByUrl('/login');
  } 

    //this.resetTimeOut("init");

   
    /* this.idle.setAutoResume(AutoResume.notIdle);
    this.idle.watch() */
    /* alert(this.sessionService.getState());

    if(this.sessionService.getState() == "TIMED_OUT")
    { */
     // this.resetTimeOut("init");
   /*  } */
    
    //this.sessionService.setIdleObject(this.idle);

    //this.resetTimeOut();

  // this.resetTimeOut();
  
    
  }

  getTitle() {
    return `Client List`
  }


  //Clear  Filter data
  clearFilter(event){
    this.dataGrid.instance.clearFilter();
  }
  getFullYear(){
    return new Date().getFullYear();
  }
}
